/*!
 * tw-bundles.js - Tiny Wishes bundle engine.
 * Alpine components for the four bundle sections:
 *   twCrossSell  (sections/bundle-cross-sell.liquid)
 *   twVolume     (sections/bundle-volume.liquid)
 *   twMix        (sections/bundle-mix-match.liquid)
 *   twBox        (sections/bundle-build-box.liquid)
 * Must load BEFORE clyro-alpine.js (components register on alpine:init).
 *
 * Discounts: a theme cannot discount on its own. Each bundle carries the
 * Shopify discount CODE the merchant created; after adding to cart we send the
 * shopper through /discount/CODE?redirect=... so Shopify applies it. Savings
 * are only displayed when a code (or a matching automatic discount) is set.
 */
(function () {
  var cfg = window.themeSettings || {};

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function rate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r && isFinite(r) ? r : 1;
  }
  function money(cents) {
    return window.clyroShop && window.clyroShop.money ? window.clyroShop.money(cents) : (Number(cents || 0) / 100).toFixed(2);
  }
  function applyDiscount(total, type, value) {
    value = Number(value) || 0;
    if (value <= 0) return total;
    if (type === 'percent') return Math.round(total * (100 - Math.min(100, value)) / 100);
    if (type === 'fixed') return Math.max(0, total - Math.round(value * 100 * rate()));
    return total;
  }
  function merge(list) {
    var map = {}, out = [];
    list.forEach(function (i) {
      if (!i.id || !(i.quantity > 0)) return;
      var k = String(i.id) + '|' + (i.selling_plan || '');
      if (map[k]) { map[k].quantity += i.quantity; }
      else {
        map[k] = { id: Number(i.id), quantity: i.quantity, properties: i.properties || {} };
        if (i.selling_plan) map[k].selling_plan = Number(i.selling_plan);
        out.push(map[k]);
      }
    });
    return out;
  }
  function after(code) {
    var type = cfg.cartType || 'drawer';
    var dest = type === 'checkout' ? (cfg.checkoutUrl || '/checkout') : (cfg.cartUrl || '/cart');
    if (code) {
      window.location.href = root() + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest);
      return;
    }
    if (type === 'drawer' && window.clyroShop && window.Alpine) {
      return window.clyroShop.refresh().then(function () {
        var s = window.Alpine.store('cart');
        if (s) s.open = true;
      });
    }
    window.location.href = dest;
  }
  function addItems(list, code) {
    var items = merge(list);
    if (!items.length) return Promise.reject(new Error('Please choose at least one item.'));
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart. Please try again.');
          return d;
        });
      })
      .then(function (d) { return Promise.resolve(after(code)).then(function () { return d; }); });
  }
  function findVariant(variants, id) {
    for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) return variants[i]; }
    return variants[0];
  }

  window.twBundle = { add: addItems, money: money, applyDiscount: applyDiscount };

  document.addEventListener('alpine:init', function () {
    var A = window.Alpine;

    function base(c) {
      return {
        c: c,
        loading: false,
        error: '',
        money: money,
        busy: function (p) {
          var self = this;
          self.loading = true;
          self.error = '';
          return p.catch(function (e) { self.error = (e && e.message) || 'Something went wrong.'; })
            .then(function () { self.loading = false; });
        }
      };
    }

    // ── Cross-sell: fixed set of products bought together ─────────
    A.data('twCrossSell', function (c) {
      return Object.assign(base(c), {
        items: c.items.map(function (it) { return { qty: it.qty, vid: it.vid, variants: it.variants }; }),
        v: function (i) { var it = this.items[i]; return findVariant(it.variants, it.vid); },
        sum: function () { var s = 0; for (var i = 0; i < this.items.length; i++) s += this.v(i).price * this.items[i].qty; return s; },
        compareSum: function () {
          var s = 0;
          for (var i = 0; i < this.items.length; i++) { var v = this.v(i); s += Math.max(v.compare || 0, v.price) * this.items[i].qty; }
          return s;
        },
        saves: function () { return !!c.showSavings; },
        final: function () { return this.saves() ? applyDiscount(this.sum(), c.dtype, c.dvalue) : this.sum(); },
        ok: function () { if (this.items.length < 2) return false; for (var i = 0; i < this.items.length; i++) { if (!this.v(i).available) return false; } return true; },
        add: function () {
          var self = this;
          var list = this.items.map(function (it, i) { return { id: self.v(i).id, quantity: it.qty, properties: { _bundle: c.name } }; });
          return this.busy(addItems(list, c.code));
        }
      });
    });

    // ── Volume: buy more of one product, pick a variant per unit ───
    A.data('twVolume', function (c) {
      return Object.assign(base(c), {
        tier: c.defaultTier || 0,
        units: [],
        init: function () {
          var self = this;
          this.fit();
          this.$watch('tier', function () { self.fit(); });
        },
        fit: function () {
          var t = c.tiers[this.tier];
          var n = t ? t.qty : 1;
          var u = this.units.slice(0, n);
          while (u.length < n) u.push(u.length ? u[u.length - 1] : c.defaultVid);
          this.units = u;
        },
        vp: function (id) { return findVariant(c.variants, id); },
        base: function (t) {
          if (t === this.tier) { var s = 0, self = this; this.units.forEach(function (id) { s += self.vp(id).price; }); return s; }
          return this.vp(c.defaultVid).price * c.tiers[t].qty;
        },
        saves: function (t) { var tt = c.tiers[t]; return !!(tt && tt.discount > 0 && (tt.code || c.code || c.auto)); },
        tierFinal: function (t) { return this.saves(t) ? applyDiscount(this.base(t), 'percent', c.tiers[t].discount) : this.base(t); },
        qtyOf: function (t) { return (c.tiers[t] && c.tiers[t].qty) || 1; },
        unit: function (t) { return Math.round(this.tierFinal(t) / this.qtyOf(t)); },
        unitBase: function (t) { return Math.round(this.base(t) / this.qtyOf(t)); },
        pctOff: function (t) { return this.saves(t) ? c.tiers[t].discount : 0; },
        ok: function () { var self = this; return this.units.length > 0 && this.units.every(function (id) { return self.vp(id).available; }); },
        add: function () {
          var tt = c.tiers[this.tier];
          var list = this.units.map(function (id) { return { id: id, quantity: 1, properties: { _bundle: c.name } }; });
          return this.busy(addItems(list, (tt && tt.code) || c.code));
        }
      });
    });

    // ── Mix & match: fill a pack from one product's variants ───────
    A.data('twMix', function (c) {
      return Object.assign(base(c), {
        pack: c.defaultPack || 0,
        counts: {},
        size: function () { var p = c.packs[this.pack]; return p ? p.size : 0; },
        count: function () { var s = 0; for (var k in this.counts) s += this.counts[k]; return s; },
        n: function (id) { return this.counts[id] || 0; },
        inc: function (id) { if (this.count() >= this.size()) return; var o = Object.assign({}, this.counts); o[id] = (o[id] || 0) + 1; this.counts = o; },
        dec: function (id) { if (!this.counts[id]) return; var o = Object.assign({}, this.counts); o[id]--; if (!o[id]) delete o[id]; this.counts = o; },
        setPack: function (i) { this.pack = i; if (this.count() > this.size()) this.counts = {}; },
        vp: function (id) { return findVariant(c.variants, id); },
        sum: function () { var s = 0; for (var k in this.counts) s += this.vp(k).price * this.counts[k]; return s; },
        saves: function () { var p = c.packs[this.pack]; return !!(p && p.discount > 0 && (p.code || c.code || c.auto)); },
        final: function () { var p = c.packs[this.pack]; return this.saves() ? applyDiscount(this.sum(), 'percent', p.discount) : this.sum(); },
        pct: function () { var s = this.size(); return s ? Math.min(100, Math.round(this.count() / s * 100)) : 0; },
        ok: function () { return this.size() > 0 && this.count() === this.size(); },
        add: function () {
          var p = c.packs[this.pack];
          var self = this;
          var list = Object.keys(this.counts).map(function (k) {
            return { id: k, quantity: self.counts[k], properties: { _bundle: c.name + ' (' + p.label + ')' } };
          });
          return this.busy(addItems(list, p.code || c.code));
        }
      });
    });

    // ── Build a box: multi-step picker from a collection ──────────
    A.data('twBox', function (c) {
      return Object.assign(base(c), {
        step: 0,
        counts: {},
        sel: {},
        note: '',
        pv: function (p) { return findVariant(p.variants, this.sel[p.id] || p.vid); },
        count: function () { var s = 0; for (var k in this.counts) s += this.counts[k]; return s; },
        n: function (id) { return this.counts[id] || 0; },
        full: function () { return c.max > 0 && this.count() >= c.max; },
        inc: function (id) { if (this.full()) return; var o = Object.assign({}, this.counts); o[id] = (o[id] || 0) + 1; this.counts = o; },
        dec: function (id) { if (!this.counts[id]) return; var o = Object.assign({}, this.counts); o[id]--; if (!o[id]) delete o[id]; this.counts = o; },
        find: function (id) {
          for (var i = 0; i < c.products.length; i++) {
            var p = c.products[i];
            for (var j = 0; j < p.variants.length; j++) { if (String(p.variants[j].id) === String(id)) return { p: p, v: p.variants[j] }; }
          }
          return null;
        },
        lines: function () {
          var self = this;
          return Object.keys(this.counts).map(function (k) {
            var r = self.find(k);
            return r ? { id: k, qty: self.counts[k], title: r.p.title, vt: r.v.title, image: r.v.image || r.p.image, price: r.v.price } : null;
          }).filter(Boolean);
        },
        sum: function () { return this.lines().reduce(function (s, l) { return s + l.price * l.qty; }, 0); },
        saves: function () { return !!c.showSavings; },
        final: function () { return this.saves() ? applyDiscount(this.sum(), c.dtype, c.dvalue) : this.sum(); },
        ready: function () { var n = this.count(); return n >= Math.max(1, c.min) && (!c.max || n <= c.max); },
        steps: function () { return c.showMessage ? 3 : 2; },
        isReview: function () { return this.step === this.steps() - 1; },
        next: function () { if (this.step === 0 && !this.ready()) return; this.step = Math.min(this.step + 1, this.steps() - 1); },
        back: function () { this.step = Math.max(0, this.step - 1); },
        add: function () {
          var note = (this.note || '').trim();
          var list = this.lines().map(function (l, i) {
            var pr = { _bundle: c.name };
            if (i === 0 && note) pr['Gift message'] = note;
            return { id: l.id, quantity: l.qty, properties: pr };
          });
          return this.busy(addItems(list, c.code));
        }
      });
    });
  });
})();
